webpackJsonp([22],{

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/javascript/components/std/Markdown.vue":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// <template>
//     {{{ parsedText }}}
// </template>
// <script>
var showdown = __webpack_require__("./node_modules/showdown/dist/showdown.js");
var converter = new showdown.Converter();
exports.default = {
    props: {
        text: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            parsedText: null
        };
    },
    ready: function ready() {
        this.parseText();
    },

    methods: {
        parseText: function parseText() {
            if (this.text) {
                this.parsedText = converter.makeHtml(this.text);
            } else {
                this.parsedText = null;
            }
        }
    },
    watch: {
        text: function text() {
            this.parseText();
        }
    }
    // </script>
    /* generated by vue-loader */

};

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/javascript/routes/terms/components/Index.vue":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// <template>
//     <div class="row">
//         <div class="col-md-offset-2 col-md-8">
//             <div class="portlet light">
//                 <div class="portlet-title" style="display: flex; align-items: center;">
//                     <div class="caption caption-md" style="width: 100%">
//                         <i class="icon-bar-chart theme-font hide"></i>
//                         <span class="sub-caption">Termos e Condições de uso</span>
//                     </div>
//                     <div style="flex-shrink: 0" v-if="$user">{{ $user.name }} ({{ $user.email }})</div>
//                 </div>
//                 <div class="portlet-body form" v-if="loading || !activeData">
//                     <h4 style="text-align: center; padding: 30px">Carregando...</h4>
//                 </div>
//                 <div lass="portlet-body form" v-if="(!loading && !activeData) && !list.length">
//                     <h4 style="text-align: center; padding: 30px">Não há termos disponíveis...</h4>
//                 </div>
//                 <div lass="portlet-body form" v-if="(!loading && activeData) && list.length">
//                     <div class="alert alert-danger" v-if="pendingAgreements && pendingAgreements.length">
//                         Você precisa aceitar os termos para utilizar o SCI Online, termos pendentes:
//                         <b>{{ pendingAgreements }}</b>
//                     </div>
//                     <div class="tabbable-panel">
//                         <div class="caption caption-md tabbable-line">
//                             <i class="icon-bar-chart theme-font hide"></i>
//                             <ul class="nav nav-tabs">
//                                 <li v-for="item in visibleList" :class="{active: item.alias === active}" v-tooltip
//                                     :title="statusTitle(item)" @click="navigateTo(item)">
//                                     <a class="sub-caption" href="javascript:;">
//                                         {{ item.name }}
//                                         <span v-if="item.agreeable && status">
//                                             <i class="fa" :class="statusIconOf(item.id)"></i>
//                                         </span>
//                                     </a>
//                                 </li>
//                             </ul>
//                         </div>
//                     </div>
//                     <div class="row">
//                         <div class="col-md-12 terms-content">
//                             <div class="content border-line">
//                                 <markdown :text="activeData.lastContract.contract"></markdown>
//                             </div>
//
//                             <div class="clearfix" v-if="activeStatus && (!activeStatus.isAccepted && activeData.agreeable)">
//                                 <div class="terms-footer remove-form-group-margin">
//                                     <div class="terms-footer-item">
//                                         <div style="margin-right: 5px">
//                                             <form-new-check :compact="true"
//                                                             label="Declaro que li e aceito os termos acima dispostos"
//                                                             :model.sync="form.agreed"></form-new-check>
//                                         </div>
//                                         <div style="margin-right: 5px">
//                                             <button class="btn orange"
//                                                     :disabled="!form.agreed && activeData.required"
//                                                     @click="accept()">CONTINUAR
//                                             </button>
//                                         </div>
//                                     </div>
//                                     <div class="terms-footer-item"
//                                          v-if="activeData && !activeData.required">
//                                         <div class="text-muted">
//                                             Esse termo não é obrigatório, mas algumas funcionalidades podem ficar
//                                             indisponíveis, caso não aceite.
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>
// </template>
//
// <script>
var $ = __webpack_require__("./node_modules/jquery/dist/jquery.js");
var R = __webpack_require__("./node_modules/ramda/index.js");
var Promise = __webpack_require__("./node_modules/bluebird/js/browser/bluebird.js");
var agreementClient = __webpack_require__("./resources/assets/javascript/sci/helpers/agreement-client.js");
var Markdown = __webpack_require__("./resources/assets/javascript/components/std/Markdown.vue");

var defaultForm = function defaultForm() {
    return { agreed: false };
};

exports.default = {
    name: 'index',
    components: { Markdown: Markdown },
    route: {
        canReuse: function canReuse() {
            return false;
        }
    },
    data: function data() {
        return {
            skipped: [],
            loading: true,
            previous: null,
            required: [],
            active: null,
            list: null,
            status: null,
            pendingAgreements: false,
            form: defaultForm()
        };
    },
    ready: function ready() {
        var _this = this;

        this.active = this.$route.params.alias || null;

        if (this.$route.query.previous) {
            this.previous = atob(this.$route.query.previous);
        }

        if (this.$route.query.required) {
            var required = [];
            var parsedRequired = JSON.parse(atob(this.$route.query.required));

            if (Array.isArray(parsedRequired)) {
                required = parsedRequired;
            }

            this.required = required;
        }

        this.load().then(function () {
            if (_this.$route.params.alias) {
                if (_this.list.find(function (_) {
                    return _.alias === _this.$route.params.alias;
                })) {
                    return;
                }
            }

            if (_this.$route.query.ignoreStatus) {
                _this.active = R.path([0, 'alias'], _this.list);
            } else {
                _this.active = _this.next();
            }
        });
    },

    methods: {
        load: function load() {
            var _this2 = this;

            this.loading = true;
            return Promise.props({
                listRes: agreementClient.post(null, '', {
                    query: '\n                            query {\n                                list {\n                                    id\n                                    required\n                                    agreeable\n                                    alias\n                                    name\n                                    description\n                                    lastContract {\n                                        id\n                                        draft\n                                        excerpt\n                                        contract\n                                        createdAt\n                                        updatedAt\n                                    }\n                                }\n                            }\n                        '
                }),
                statusRes: this.$user ? agreementClient.post(null, '', {
                    query: '\n                            query($overrideRequired: [String!]) {\n                                status(overrideRequired: $overrideRequired) {\n                                    type {\n                                        id\n                                        required\n                                        agreeable\n                                        alias\n                                        name\n                                        description\n                                    }\n                                    isOk\n                                    isAccepted\n                                    lastAcceptedContract {\n                                        id\n                                    }\n                                    lastAvailableContract {\n                                        id\n                                    }\n                                }\n                            }\n                        ',
                    variables: {
                        overrideRequired: this.required
                    }
                }) : null
            }).then(function (_ref) {
                var listRes = _ref.listRes,
                    statusRes = _ref.statusRes;

                _this2.list = R.sortBy(function (_) {
                    return _.id;
                }, listRes.data.list);

                if (statusRes) {
                    _this2.status = statusRes.data.status;
                    _this2.pendingAgreements = _this2.status.filter(function (_) {
                        return !_.isOk;
                    }).map(function (_) {
                        return _.type.name;
                    }).join(', ');
                }

                _this2.loading = false;

                return { list: _this2.list, pending: _this2.pendingAgreements, status: _this2.status };
            });
        },
        navigateTo: function navigateTo(item) {
            this.form = defaultForm();
            this.active = item.alias;
            $(document).scrollTo(0, 0);
            this.load();
            // this.$router.go({ name: 'terms-by-alias', params: { alias: item.alias }, query: this.$route.query })
        },
        next: function next() {
            var fallbackToDefault = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (this.status) {
                for (var _iterator = this.status, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref2;

                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref2 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref2 = _i.value;
                    }

                    var current = _ref2;

                    if (!current.isOk && this.skipped.indexOf(current.type.alias) === -1) {
                        return current.type.alias;
                    }
                }

                for (var _iterator2 = this.status, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref3;

                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref3 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref3 = _i2.value;
                    }

                    var _current = _ref3;

                    if (!_current.isAccepted && _current.type.agreeable && this.skipped.indexOf(_current.type.alias) === -1) {
                        return _current.type.alias;
                    }
                }
            }

            if (this.list.length && fallbackToDefault) {
                return this.list[0].alias;
            }

            return null;

            // if (this.list.length) {
            //     this.active = this.active ||
            //         R.pathOr(null, ['type', 'alias'], this.status.find(_ => !_.isAccepted)) ||
            //         this.list[0].alias
            // }
        },
        accept: function accept() {
            var _this3 = this;

            var data = this.activeData;
            if (this.form.agreed) {
                if (data.lastContract) {
                    this.loading = true;
                    agreementClient.post(null, '', {
                        query: '\n                                mutation($ids: [Long!]!) {\n                                    agree(ids: $ids)\n                                }\n                            ',
                        variables: {
                            ids: [data.lastContract.id]
                        }
                    }).then(function () {
                        _this3.form = defaultForm();
                        _this3.active = null;
                        return _this3.load();
                    }).then(function (res) {
                        var next = _this3.next(false);

                        if (next) {
                            _this3.active = next;
                        } else {
                            if (_this3.previous) {
                                location.href = _this3.previous;
                            } else {
                                location.href = '/';
                            }
                        }
                    });
                }
            } else {
                this.skipped.push(data.alias);

                var next = this.next(false);

                if (!next) {
                    if (this.previous) {
                        location.href = this.previous;
                    } else {
                        location.href = '/';
                    }
                } else {
                    this.active = next;
                    this.form = defaultForm();
                }
            }
        },
        statusTitle: function statusTitle(item) {
            if (!item.agreeable) {
                return null;
            }

            if (item.required) {
                return 'Obrigatório';
            }

            return 'Não é obrigatório, mas algumas funcionalidades podem ficar indisponíveis.';
        },
        statusIconOf: function statusIconOf(id) {
            if (!this.status) {
                return null;
            }

            var status = this.status.find(function (_) {
                return _.type.id === id;
            });

            if (status) {
                if (status.isOk) {
                    if (status.isAccepted) {
                        return ['fa-check-circle', 'text-success'];
                    } else {
                        return ['fa-times-circle', 'text-warning'];
                    }
                } else {
                    return ['fa-times-circle', 'text-danger'];
                }
            }
        }
    },
    computed: {
        activeData: function activeData() {
            var _this4 = this;

            return this.list && this.list.find(function (_) {
                return _.alias === _this4.active;
            });
        },
        activeStatus: function activeStatus() {
            var _this5 = this;

            return this.status && this.status.find(function (_) {
                return _.type.alias === _this5.active;
            });
        },
        visibleList: function visibleList() {
            return this.list.filter(function (_) {
                return _.lastContract;
            });
        }
    }
    // </script>
    //
    // <style>
    // .terms-content h1 {
    //     font-size: 26px;
    //     font-weight: 600;
    //     margin: 10px 0 30px 0;
    //     color: #343434;
    // }
    //
    // .terms-content h2 {
    //     font-size: 20px;
    //     font-weight: 600;
    //     margin: 35px 0 25px 0;
    // }
    //
    // .terms-content p {
    //     font-size: 14px;
    //     color: #444;
    //     margin: 0 0 15px 0;
    // }
    //
    // .terms-content ul li, .terms-content ol li {
    //     padding: 0 0 15px 0;
    // }
    //
    // .terms-content .content {
    //     padding: 15px 0;
    // }
    //
    // .terms-content code {
    //     box-shadow: none;
    //     border: none
    // }
    //
    // .border-line {
    //     border-top: 1px solid #eee;
    // }
    //
    // .terms-footer {
    //     padding-top: 15px;
    //     border-top: 1px solid #eee;
    //     display: flex;
    //     flex-flow: column;
    //     align-items: flex-end;
    // }
    //
    // .terms-footer-item {
    //     display: flex;
    //     align-items: center;
    //     margin-bottom: 15px;
    // }
    //
    // </style>
    /* generated by vue-loader */

};

/***/ }),

/***/ "./node_modules/brace-expansion/index.js":
/***/ (function(module, exports, __webpack_require__) {

var concatMap = __webpack_require__("./node_modules/concat-map/index.js");
var balanced = __webpack_require__("./node_modules/balanced-match/index.js");

module.exports = expandTop;

var escSlash = '\0SLASH'+Math.random()+'\0';
var escOpen = '\0OPEN'+Math.random()+'\0';
var escClose = '\0CLOSE'+Math.random()+'\0';
var escComma = '\0COMMA'+Math.random()+'\0';
var escPeriod = '\0PERIOD'+Math.random()+'\0';

function numeric(str) {
  return parseInt(str, 10) == str
    ? parseInt(str, 10)
    : str.charCodeAt(0);
}

function escapeBraces(str) {
  return str.split('\\\\').join(escSlash)
            .split('\\{').join(escOpen)
            .split('\\}').join(escClose)
            .split('\\,').join(escComma)
            .split('\\.').join(escPeriod);
}

function unescapeBraces(str) {
  return str.split(escSlash).join('\\')
            .split(escOpen).join('{')
            .split(escClose).join('}')
            .split(escComma).join(',')
            .split(escPeriod).join('.');
}


// Basically just str.split(","), but handling cases
// where we have nested braced sections, which should be
// treated as individual members, like {a,{b,c},d}
function parseCommaParts(str) {
  if (!str)
    return [''];

  var parts = [];
  var m = balanced('{', '}', str);

  if (!m)
    return str.split(',');

  var pre = m.pre;
  var body = m.body;
  var post = m.post;
  var p = pre.split(',');

  p[p.length-1] += '{' + body + '}';
  var postParts = parseCommaParts(post);
  if (post.length) {
    p[p.length-1] += postParts.shift();
    p.push.apply(p, postParts);
  }

  parts.push.apply(parts, p);

  return parts;
}

function expandTop(str) {
  if (!str)
    return [];

  // I don't know why Bash 4.3 does this, but it does.
  // Anything starting with {} will have the first two bytes preserved
  // but *only* at the top level, so {},a}b will not expand to anything,
  // but a{},b}c will be expanded to [a}c,abc].
  // One could argue that this is a bug in Bash, but since the goal of
  // this module is to match Bash's rules, we escape a leading {}
  if (str.substr(0, 2) === '{}') {
    str = '\\{\\}' + str.substr(2);
  }

  return expand(escapeBraces(str), true).map(unescapeBraces);
}

function identity(e) {
  return e;
}

function embrace(str) {
  return '{' + str + '}';
}
function isPadded(el) {
  return /^-?0\d/.test(el);
}

function lte(i, y) {
  return i <= y;
}
function gte(i, y) {
  return i >= y;
}

function expand(str, isTop) {
  var expansions = [];

  var m = balanced('{', '}', str);
  if (!m || /\$$/.test(m.pre)) return [str];

  var isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m.body);
  var isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m.body);
  var isSequence = isNumericSequence || isAlphaSequence;
  var isOptions = m.body.indexOf(',') >= 0;
  if (!isSequence && !isOptions) {
    // {a},b}
    if (m.post.match(/,.*\}/)) {
      str = m.pre + '{' + m.body + escClose + m.post;
      return expand(str);
    }
    return [str];
  }

  var n;
  if (isSequence) {
    n = m.body.split(/\.\./);
  } else {
    n = parseCommaParts(m.body);
    if (n.length === 1) {
      // x{{a,b}}y ==> x{a}y x{b}y
      n = expand(n[0], false).map(embrace);
      if (n.length === 1) {
        var post = m.post.length
          ? expand(m.post, false)
          : [''];
        return post.map(function(p) {
          return m.pre + n[0] + p;
        });
      }
    }
  }

  // at this point, n is the parts, and we know it's not a comma set
  // with a single entry.

  // no need to expand pre, since it is guaranteed to be free of brace-sets
  var pre = m.pre;
  var post = m.post.length
    ? expand(m.post, false)
    : [''];

  var N;

  if (isSequence) {
    var x = numeric(n[0]);
    var y = numeric(n[1]);
    var width = Math.max(n[0].length, n[1].length)
    var incr = n.length == 3
      ? Math.abs(numeric(n[2]))
      : 1;
    var test = lte;
    var reverse = y < x;
    if (reverse) {
      incr *= -1;
      test = gte;
    }
    var pad = n.some(isPadded);

    N = [];

    for (var i = x; test(i, y); i += incr) {
      var c;
      if (isAlphaSequence) {
        c = String.fromCharCode(i);
        if (c === '\\')
          c = '';
      } else {
        c = String(i);
        if (pad) {
          var need = width - c.length;
          if (need > 0) {
            var z = new Array(need + 1).join('0');
            if (i < 0)
              c = '-' + z + c.slice(1);
            else
              c = z + c;
          }
        }
      }
      N.push(c);
    }
  } else {
    N = concatMap(n, function(el) { return expand(el, false) });
  }

  for (var j = 0; j < N.length; j++) {
    for (var k = 0; k < post.length; k++) {
      var expansion = pre + N[j] + post[k];
      if (!isTop || isSequence || expansion)
        expansions.push(expansion);
    }
  }

  return expansions;
}



/***/ }),

/***/ "./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-rewriter.js!./node_modules/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/javascript/routes/terms/components/Index.vue":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.terms-content h1 {\n    font-size: 26px;\n    font-weight: 600;\n    margin: 10px 0 30px 0;\n    color: #343434;\n}\n\n.terms-content h2 {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 35px 0 25px 0;\n}\n\n.terms-content p {\n    font-size: 14px;\n    color: #444;\n    margin: 0 0 15px 0;\n}\n\n.terms-content ul li, .terms-content ol li {\n    padding: 0 0 15px 0;\n}\n\n.terms-content .content {\n    padding: 15px 0;\n}\n\n.terms-content code {\n    box-shadow: none;\n    border: none\n}\n\n.border-line {\n    border-top: 1px solid #eee;\n}\n\n.terms-footer {\n    padding-top: 15px;\n    border-top: 1px solid #eee;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: column;\n        flex-flow: column;\n    -ms-flex-align: end;\n        align-items: flex-end;\n}\n\n.terms-footer-item {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-bottom: 15px;\n}\n\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/resources/assets/javascript/routes/terms/components/Index.vue?56def0a5"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA6UA;IACA,gBAAA;IACA,iBAAA;IACA,sBAAA;IACA,eAAA;CACA;;AAEA;IACA,gBAAA;IACA,iBAAA;IACA,sBAAA;CACA;;AAEA;IACA,gBAAA;IACA,YAAA;IACA,mBAAA;CACA;;AAEA;IACA,oBAAA;CACA;;AAEA;IACA,gBAAA;CACA;;AAEA;IACA,iBAAA;IACA,YAAA;CACA;;AAEA;IACA,2BAAA;CACA;;AAEA;IACA,kBAAA;IACA,2BAAA;IACA,qBAAA;IAAA,cAAA;IACA,sBAAA;QAAA,kBAAA;IACA,oBAAA;QAAA,sBAAA;CACA;;AAEA;IACA,qBAAA;IAAA,cAAA;IACA,uBAAA;QAAA,oBAAA;IACA,oBAAA;CACA","file":"Index.vue","sourcesContent":["<template>\n    <div class=\"row\">\n        <div class=\"col-md-offset-2 col-md-8\">\n            <div class=\"portlet light\">\n                <div class=\"portlet-title\" style=\"display: flex; align-items: center;\">\n                    <div class=\"caption caption-md\" style=\"width: 100%\">\n                        <i class=\"icon-bar-chart theme-font hide\"></i>\n                        <span class=\"sub-caption\">Termos e Condições de uso</span>\n                    </div>\n                    <div style=\"flex-shrink: 0\" v-if=\"$user\">{{ $user.name }} ({{ $user.email }})</div>\n                </div>\n                <div class=\"portlet-body form\" v-if=\"loading || !activeData\">\n                    <h4 style=\"text-align: center; padding: 30px\">Carregando...</h4>\n                </div>\n                <div lass=\"portlet-body form\" v-if=\"(!loading && !activeData) && !list.length\">\n                    <h4 style=\"text-align: center; padding: 30px\">Não há termos disponíveis...</h4>\n                </div>\n                <div lass=\"portlet-body form\" v-if=\"(!loading && activeData) && list.length\">\n                    <div class=\"alert alert-danger\" v-if=\"pendingAgreements && pendingAgreements.length\">\n                        Você precisa aceitar os termos para utilizar o SCI Online, termos pendentes:\n                        <b>{{ pendingAgreements }}</b>\n                    </div>\n                    <div class=\"tabbable-panel\">\n                        <div class=\"caption caption-md tabbable-line\">\n                            <i class=\"icon-bar-chart theme-font hide\"></i>\n                            <ul class=\"nav nav-tabs\">\n                                <li v-for=\"item in visibleList\" :class=\"{active: item.alias === active}\" v-tooltip\n                                    :title=\"statusTitle(item)\" @click=\"navigateTo(item)\">\n                                    <a class=\"sub-caption\" href=\"javascript:;\">\n                                        {{ item.name }}\n                                        <span v-if=\"item.agreeable && status\">\n                                            <i class=\"fa\" :class=\"statusIconOf(item.id)\"></i>\n                                        </span>\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-12 terms-content\">\n                            <div class=\"content border-line\">\n                                <markdown :text=\"activeData.lastContract.contract\"></markdown>\n                            </div>\n\n                            <div class=\"clearfix\" v-if=\"activeStatus && (!activeStatus.isAccepted && activeData.agreeable)\">\n                                <div class=\"terms-footer remove-form-group-margin\">\n                                    <div class=\"terms-footer-item\">\n                                        <div style=\"margin-right: 5px\">\n                                            <form-new-check :compact=\"true\"\n                                                            label=\"Declaro que li e aceito os termos acima dispostos\"\n                                                            :model.sync=\"form.agreed\"></form-new-check>\n                                        </div>\n                                        <div style=\"margin-right: 5px\">\n                                            <button class=\"btn orange\"\n                                                    :disabled=\"!form.agreed && activeData.required\"\n                                                    @click=\"accept()\">CONTINUAR\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class=\"terms-footer-item\"\n                                         v-if=\"activeData && !activeData.required\">\n                                        <div class=\"text-muted\">\n                                            Esse termo não é obrigatório, mas algumas funcionalidades podem ficar\n                                            indisponíveis, caso não aceite.\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</template>\n\n<script>\nconst $ = require('jquery')\nconst R = require('ramda')\nconst Promise = require('bluebird')\nconst agreementClient = require('sci/helpers/agreement-client')\nconst Markdown = require('components/std/Markdown.vue')\n\nconst defaultForm = () => ({ agreed: false })\n\nexport default {\n    name: 'index',\n    components: { Markdown },\n    route: {\n        canReuse () {\n            return false\n        }\n    },\n    data () {\n        return {\n            skipped: [],\n            loading: true,\n            previous: null,\n            required: [],\n            active: null,\n            list: null,\n            status: null,\n            pendingAgreements: false,\n            form: defaultForm()\n        }\n    },\n    ready () {\n        this.active = this.$route.params.alias || null\n\n        if (this.$route.query.previous) {\n            this.previous = atob(this.$route.query.previous)\n        }\n\n        if (this.$route.query.required) {\n            let required = []\n            const parsedRequired = JSON.parse(atob(this.$route.query.required))\n\n            if (Array.isArray(parsedRequired)) {\n                required = parsedRequired\n            }\n\n            this.required = required\n        }\n\n        this.load().then(() => {\n            if (this.$route.params.alias) {\n                if (this.list.find(_ => _.alias === this.$route.params.alias)) {\n                    return\n                }\n            }\n\n            if (this.$route.query.ignoreStatus) {\n                this.active = R.path([0, 'alias'], this.list)\n            } else {\n                this.active = this.next()\n            }\n        })\n    },\n    methods: {\n        load () {\n            this.loading = true\n            return Promise.props({\n                listRes: agreementClient.post(null, '', {\n                    query: `\n                            query {\n                                list {\n                                    id\n                                    required\n                                    agreeable\n                                    alias\n                                    name\n                                    description\n                                    lastContract {\n                                        id\n                                        draft\n                                        excerpt\n                                        contract\n                                        createdAt\n                                        updatedAt\n                                    }\n                                }\n                            }\n                        `\n                }),\n                statusRes: this.$user ? agreementClient.post(null, '', {\n                    query: `\n                            query($overrideRequired: [String!]) {\n                                status(overrideRequired: $overrideRequired) {\n                                    type {\n                                        id\n                                        required\n                                        agreeable\n                                        alias\n                                        name\n                                        description\n                                    }\n                                    isOk\n                                    isAccepted\n                                    lastAcceptedContract {\n                                        id\n                                    }\n                                    lastAvailableContract {\n                                        id\n                                    }\n                                }\n                            }\n                        `,\n                    variables: {\n                        overrideRequired: this.required\n                    }\n                }) : null\n            }).then(({ listRes, statusRes }) => {\n                this.list = R.sortBy(_ => _.id, listRes.data.list)\n\n                if (statusRes) {\n                    this.status = statusRes.data.status\n                    this.pendingAgreements = this.status.filter(_ => !_.isOk).map(_ => _.type.name).join(', ')\n                }\n\n                this.loading = false\n\n                return { list: this.list, pending: this.pendingAgreements, status: this.status }\n            })\n        },\n        navigateTo (item) {\n            this.form = defaultForm()\n            this.active = item.alias\n            $(document).scrollTo(0, 0)\n            this.load()\n            // this.$router.go({ name: 'terms-by-alias', params: { alias: item.alias }, query: this.$route.query })\n        },\n        next (fallbackToDefault = true) {\n            if (this.status) {\n                for (const current of this.status) {\n                    if (!current.isOk && this.skipped.indexOf(current.type.alias) === -1) {\n                        return current.type.alias\n                    }\n                }\n\n                for (const current of this.status) {\n                    if (!current.isAccepted && current.type.agreeable && this.skipped.indexOf(current.type.alias) === -1) {\n                        return current.type.alias\n                    }\n                }\n            }\n\n            if (this.list.length && fallbackToDefault) {\n                return this.list[0].alias\n            }\n\n            return null\n\n            // if (this.list.length) {\n            //     this.active = this.active ||\n            //         R.pathOr(null, ['type', 'alias'], this.status.find(_ => !_.isAccepted)) ||\n            //         this.list[0].alias\n            // }\n        },\n        accept () {\n            const data = this.activeData\n            if (this.form.agreed) {\n                if (data.lastContract) {\n                    this.loading = true\n                    agreementClient.post(null, '', {\n                        query: `\n                                mutation($ids: [Long!]!) {\n                                    agree(ids: $ids)\n                                }\n                            `,\n                        variables: {\n                            ids: [data.lastContract.id]\n                        }\n                    }).then(() => {\n                        this.form = defaultForm()\n                        this.active = null\n                        return this.load()\n                    }).then((res) => {\n                        const next = this.next(false)\n\n                        if (next) {\n                            this.active = next\n                        } else {\n                            if (this.previous) {\n                                location.href = this.previous\n                            } else {\n                                location.href = '/'\n                            }\n                        }\n                    })\n                }\n            } else {\n                this.skipped.push(data.alias)\n\n                const next = this.next(false)\n\n                if (!next) {\n                    if (this.previous) {\n                        location.href = this.previous\n                    } else {\n                        location.href = '/'\n                    }\n                } else {\n                    this.active = next\n                    this.form = defaultForm()\n                }\n            }\n        },\n        statusTitle (item) {\n            if (!item.agreeable) {\n                return null\n            }\n\n            if (item.required) {\n                return 'Obrigatório'\n            }\n\n            return 'Não é obrigatório, mas algumas funcionalidades podem ficar indisponíveis.'\n        },\n        statusIconOf (id) {\n            if (!this.status) {\n                return null\n            }\n\n            const status = this.status.find(_ => _.type.id === id)\n\n            if (status) {\n                if (status.isOk) {\n                    if (status.isAccepted) {\n                        return ['fa-check-circle', 'text-success']\n                    } else {\n                        return ['fa-times-circle', 'text-warning']\n                    }\n                } else {\n                    return ['fa-times-circle', 'text-danger']\n                }\n            }\n        }\n    },\n    computed: {\n        activeData () {\n            return this.list && this.list.find(_ => _.alias === this.active)\n        },\n        activeStatus () {\n            return this.status && this.status.find(_ => _.type.alias === this.active)\n        },\n        visibleList () {\n            return this.list.filter(_ => _.lastContract)\n        }\n    }\n}\n</script>\n\n<style>\n.terms-content h1 {\n    font-size: 26px;\n    font-weight: 600;\n    margin: 10px 0 30px 0;\n    color: #343434;\n}\n\n.terms-content h2 {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 35px 0 25px 0;\n}\n\n.terms-content p {\n    font-size: 14px;\n    color: #444;\n    margin: 0 0 15px 0;\n}\n\n.terms-content ul li, .terms-content ol li {\n    padding: 0 0 15px 0;\n}\n\n.terms-content .content {\n    padding: 15px 0;\n}\n\n.terms-content code {\n    box-shadow: none;\n    border: none\n}\n\n.border-line {\n    border-top: 1px solid #eee;\n}\n\n.terms-footer {\n    padding-top: 15px;\n    border-top: 1px solid #eee;\n    display: flex;\n    flex-flow: column;\n    align-items: flex-end;\n}\n\n.terms-footer-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n</style>"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/std/Markdown.vue":
/***/ (function(module, exports) {

module.exports = "\n{{{ parsedText }}}\n";

/***/ }),

/***/ "./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/routes/terms/components/Index.vue":
/***/ (function(module, exports) {

module.exports = "\n<div class=\"row\">\n    <div class=\"col-md-offset-2 col-md-8\">\n        <div class=\"portlet light\">\n            <div class=\"portlet-title\" style=\"display: flex; align-items: center;\">\n                <div class=\"caption caption-md\" style=\"width: 100%\">\n                    <i class=\"icon-bar-chart theme-font hide\"></i>\n                    <span class=\"sub-caption\">Termos e Condições de uso</span>\n                </div>\n                <div style=\"flex-shrink: 0\" v-if=\"$user\">{{ $user.name }} ({{ $user.email }})</div>\n            </div>\n            <div class=\"portlet-body form\" v-if=\"loading || !activeData\">\n                <h4 style=\"text-align: center; padding: 30px\">Carregando...</h4>\n            </div>\n            <div lass=\"portlet-body form\" v-if=\"(!loading && !activeData) && !list.length\">\n                <h4 style=\"text-align: center; padding: 30px\">Não há termos disponíveis...</h4>\n            </div>\n            <div lass=\"portlet-body form\" v-if=\"(!loading && activeData) && list.length\">\n                <div class=\"alert alert-danger\" v-if=\"pendingAgreements && pendingAgreements.length\">\n                    Você precisa aceitar os termos para utilizar o SCI Online, termos pendentes:\n                    <b>{{ pendingAgreements }}</b>\n                </div>\n                <div class=\"tabbable-panel\">\n                    <div class=\"caption caption-md tabbable-line\">\n                        <i class=\"icon-bar-chart theme-font hide\"></i>\n                        <ul class=\"nav nav-tabs\">\n                            <li v-for=\"item in visibleList\" :class=\"{active: item.alias === active}\" v-tooltip\n                                :title=\"statusTitle(item)\" @click=\"navigateTo(item)\">\n                                <a class=\"sub-caption\" href=\"javascript:;\">\n                                    {{ item.name }}\n                                    <span v-if=\"item.agreeable && status\">\n                                        <i class=\"fa\" :class=\"statusIconOf(item.id)\"></i>\n                                    </span>\n                                </a>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-12 terms-content\">\n                        <div class=\"content border-line\">\n                            <markdown :text=\"activeData.lastContract.contract\"></markdown>\n                        </div>\n\n                        <div class=\"clearfix\" v-if=\"activeStatus && (!activeStatus.isAccepted && activeData.agreeable)\">\n                            <div class=\"terms-footer remove-form-group-margin\">\n                                <div class=\"terms-footer-item\">\n                                    <div style=\"margin-right: 5px\">\n                                        <form-new-check :compact=\"true\"\n                                                        label=\"Declaro que li e aceito os termos acima dispostos\"\n                                                        :model.sync=\"form.agreed\"></form-new-check>\n                                    </div>\n                                    <div style=\"margin-right: 5px\">\n                                        <button class=\"btn orange\"\n                                                :disabled=\"!form.agreed && activeData.required\"\n                                                @click=\"accept()\">CONTINUAR\n                                        </button>\n                                    </div>\n                                </div>\n                                <div class=\"terms-footer-item\"\n                                     v-if=\"activeData && !activeData.required\">\n                                    <div class=\"text-muted\">\n                                        Esse termo não é obrigatório, mas algumas funcionalidades podem ficar\n                                        indisponíveis, caso não aceite.\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),

/***/ "./node_modules/vue-style-loader/index.js!./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-rewriter.js!./node_modules/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/javascript/routes/terms/components/Index.vue":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-rewriter.js!./node_modules/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/javascript/routes/terms/components/Index.vue");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("./node_modules/vue-style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../../node_modules/vue-loader/lib/style-rewriter.js!../../../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Index.vue", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../../node_modules/vue-loader/lib/style-rewriter.js!../../../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Index.vue");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./resources/assets/javascript/components/std/Markdown.vue":
/***/ (function(module, exports, __webpack_require__) {

var __vue_script__, __vue_template__
var __vue_styles__ = {}
__vue_script__ = __webpack_require__("./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/javascript/components/std/Markdown.vue")
if (Object.keys(__vue_script__).some(function (key) { return key !== "default" && key !== "__esModule" })) {
  console.warn("[vue-loader] resources/assets/javascript/components/std/Markdown.vue: named exports in *.vue files are ignored.")}
__vue_template__ = __webpack_require__("./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/std/Markdown.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})
if (false) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  var id = "_v-0b960de6/Markdown.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, __vue_template__)
  }
})()}

/***/ }),

/***/ "./resources/assets/javascript/routes/terms/components/Index.vue":
/***/ (function(module, exports, __webpack_require__) {

var __vue_script__, __vue_template__
var __vue_styles__ = {}
__webpack_require__("./node_modules/vue-style-loader/index.js!./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-rewriter.js!./node_modules/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/javascript/routes/terms/components/Index.vue")
__vue_script__ = __webpack_require__("./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/javascript/routes/terms/components/Index.vue")
if (Object.keys(__vue_script__).some(function (key) { return key !== "default" && key !== "__esModule" })) {
  console.warn("[vue-loader] resources/assets/javascript/routes/terms/components/Index.vue: named exports in *.vue files are ignored.")}
__vue_template__ = __webpack_require__("./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/routes/terms/components/Index.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})
if (false) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  var id = "_v-d1e9a442/Index.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, __vue_template__)
  }
})()}

/***/ }),

/***/ "./resources/assets/javascript/routes/terms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SCI = __webpack_require__("./resources/assets/javascript/sci/index.js");

var routerBuilder = __webpack_require__("./resources/assets/javascript/routes/terms/router.js");

SCI.bootVueRouter(routerBuilder);

/***/ }),

/***/ "./resources/assets/javascript/routes/terms/router.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (router) {
    router.map({
        '/terms': {
            component: __webpack_require__("./resources/assets/javascript/routes/terms/components/Index.vue"),
            name: 'terms'
        },
        '/terms/:alias': {
            component: __webpack_require__("./resources/assets/javascript/routes/terms/components/Index.vue"),
            name: 'terms-by-alias'
        }
    });
};

/***/ }),

/***/ "./resources/assets/javascript/sci/helpers/agreement-client.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__("./resources/assets/javascript/sci/helpers/base-client.js"),
    BaseClient = _require.BaseClient,
    setupClient = _require.setupClient;

var _require2 = __webpack_require__("./resources/assets/javascript/sci/utils.js"),
    agreementUrl = _require2.agreementUrl;

var Client = function (_BaseClient) {
    _inherits(Client, _BaseClient);

    function Client() {
        _classCallCheck(this, Client);

        return _possibleConstructorReturn(this, _BaseClient.apply(this, arguments));
    }

    Client.prototype.url = function url(path) {
        return agreementUrl(path);
    };

    return Client;
}(BaseClient);

module.exports = setupClient(Client);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = window;

/***/ })

},["./resources/assets/javascript/routes/terms/index.js"]);


// WEBPACK FOOTER //
// terms.min.js